module.exports = __webpack_public_path__ + "img/bay-room-5.bc75e326.jpg";